var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfobtnblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_665049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3366 16.091C13.1322 16.1101 12.9269 16.064 12.7503 15.9592C12.6212 15.8267 12.5593 15.6428 12.5821 15.4592C12.5869 15.3064 12.6051 15.1543 12.6366 15.0047C12.6671 14.833 12.7066 14.6631 12.7548 14.4956L13.2912 12.6501C13.3465 12.4679 13.383 12.2806 13.4003 12.091C13.4003 11.8865 13.4275 11.7455 13.4275 11.6637C13.4389 11.2992 13.2833 10.9493 13.0048 10.7137C12.6623 10.4508 12.2357 10.3215 11.8048 10.3501C11.496 10.3547 11.1896 10.4053 10.8957 10.5001C10.5745 10.6001 10.2366 10.7198 9.88207 10.8592L9.72754 11.4592C9.83207 11.4228 9.95938 11.3819 10.1048 11.3365C10.2436 11.2954 10.3874 11.2739 10.5321 11.2728C10.735 11.2508 10.9393 11.3007 11.1093 11.4137C11.2248 11.5515 11.279 11.7305 11.2593 11.9092C11.2588 12.062 11.2421 12.2144 11.2093 12.3637C11.1775 12.5228 11.1366 12.691 11.0866 12.8683L10.5457 14.7228C10.5021 14.8952 10.4672 15.0696 10.4412 15.2455C10.4199 15.3961 10.4093 15.548 10.4093 15.7001C10.4071 16.0671 10.575 16.4145 10.8639 16.641C11.2117 16.908 11.6443 17.0404 12.082 17.0137C12.3902 17.02 12.6974 16.9755 12.9911 16.8819C13.2487 16.794 13.5927 16.6682 14.023 16.5046L14.1684 15.9319C14.0519 15.9802 13.9318 16.0197 13.8093 16.05C13.6544 16.0854 13.4954 16.0992 13.3366 16.091Z",
    fill: "#2490D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9041 7.34083C13.6568 7.11364 13.3308 6.99141 12.995 6.99993C12.6594 6.99235 12.3338 7.11446 12.0859 7.34083C11.6316 7.73262 11.5808 8.4186 11.9726 8.87301C12.0076 8.91352 12.0454 8.95137 12.0859 8.9863C12.6036 9.4493 13.3865 9.4493 13.9041 8.9863C14.3585 8.59063 14.4061 7.90157 14.0104 7.44719C13.9775 7.40934 13.942 7.3738 13.9041 7.34083Z",
    fill: "#2490D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 1.85C6.39431 1.85 1.85 6.39431 1.85 12C1.85 17.6057 6.39431 22.15 12 22.15C17.6057 22.15 22.15 17.6057 22.15 12C22.15 6.39431 17.6057 1.85 12 1.85ZM12 20.9409C7.06206 20.9409 3.0591 16.9379 3.0591 12C3.0591 7.06206 7.06206 3.0591 12 3.0591C16.9379 3.0591 20.9409 7.06206 20.9409 12C20.9409 16.9379 16.9379 20.9409 12 20.9409Z",
    fill: "#2490D2",
    stroke: "#2490D2",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobtnblue);
export default __webpack_public_path__ + "static/media/infobtnblue.7dffb3150c58e50295317ff24d7ae36e.svg";
export { ForwardRef as ReactComponent };